import { defineMessages } from "react-intl";

import TourDescriptor from "@app/component/flows/types/TourDescriptor";

const title = defineMessages({
  step1: {
    id: "guides.gettingStarted.groups.step1",
    defaultMessage: "Groups 🗂",
  },
  step2: {
    id: "guides.gettingStarted.groups.step2",
    defaultMessage: "Manage Groups",
  },
  step3: {
    id: "guides.gettingStarted.groups.step3",
    defaultMessage: "Group Creation",
  },
  step4: {
    id: "guides.gettingStarted.groups.step4",
    defaultMessage: "First, fill out some details about your Group",
  },
  step5: {
    id: "guides.gettingStarted.groups.step5",
    defaultMessage: "Create your Group",
  },
  step6: {
    id: "guides.gettingStarted.groups.step6",
    defaultMessage: "Nice job",
  },
});

const description = defineMessages({
  step1: {
    id: "guides.gettingStarted.groups.step1.description",
    defaultMessage:
      "Use groups to organize your records by customer tier, product line, and more! \nClick the Groups Icon to get started.",
  },
  step2: {
    id: "guides.gettingStarted.groups.step2.description",
    defaultMessage:
      "Here, you can:{br}" +
      "🔎 Search for groups{br}" +
      "✍️ Edit Groups{br}" +
      "🗺 View Groups on the Map",
  },
  step3: {
    id: "guides.gettingStarted.groups.step3.description",
    defaultMessage: "Let's get started by creating a Group.",
  },
  step4: {
    id: "guides.gettingStarted.groups.step4.description",
    defaultMessage:
      "1️⃣ Give your Group a name and color{br}" +
      "2️⃣ Assign records in this group to a frequency (a frequency will remind you to follow up with customers at regular intervals){br}" +
      "3️⃣ Share the records in the group instantly{br}" +
      '4️⃣ Click "Create" (Don\'t worry, you can delete this group later){br}',
  },
  step5: {
    id: "guides.gettingStarted.groups.step5.description",
    defaultMessage: "Select this option create a group",
  },
  step6: {
    id: "guides.gettingStarted.groups.step6.description",
    defaultMessage: "You have created a group!",
  },
});

export const groupsTour: TourDescriptor = {
  id: "getting-started-groups",
  steps: [
    {
      id: "groups-button",
      description: description.step1,
      options: {
        disableInteraction: false,
        showButtons: false,
      },
      selector:
        "div[class*=MapPage_container] div[class*=Toolbar_container] [data-menu-item=groups]",
      title: title.step1,
      waitForEvent: {
        eventType: "click",
        selector:
          "div[class*=MapPage_container] div[class*=Toolbar_container] [data-menu-item=groups]",
      },
    },
    {
      id: "groups-modal",
      description: description.step2,
      selector: "[class*=GroupsModal_modal]",
      title: title.step2,
    },
    {
      id: "groups-modal-add",
      description: description.step3,
      options: {
        disableInteraction: false,
        showButtons: false,
      },
      selector: "[class*=GroupsModal_modal] [data-id=add-or-create-button]",
      title: title.step3,
      waitForEvent: {
        eventType: "click",
        selector: "[class*=GroupsModal_modal] [data-id=add-or-create-button]",
      },
    },
    {
      id: "create-groups-modal",
      description: description.step4,
      options: {
        disableInteraction: false,
        showButtons: false,
      },
      position: "right",
      selector: "[class*=CreateGroupModal_modal]",
      title: title.step4,
      waitForEvent: {
        eventType: "click",
        selector: "[class*=CreateGroupModal_modal] [class*=Footer] .mmc-button--primary",
      },
    },
    {
      id: "create-groups-modal-dropdown",
      description: description.step5,
      options: {
        disableInteraction: false,
        expectRouteChange: true,
        showButtons: false,
      },
      selector: ".js-mmc-create-group-only",
      title: title.step5,
      waitForEvent: {
        eventType: "click",
        selector: ".js-mmc-create-group-only",
      },
    },
    {
      id: "create-groups-success",
      description: description.step6,
      onAfter: () => {
        // close Groups modal
        const closeIcon = document.querySelector("[class*=GroupsModal_modal] .ant-modal-close");
        if (closeIcon) {
          (closeIcon as HTMLElement).click();
        }

        return Promise.resolve();
      },
      title: title.step6,
    },
  ],
};
